
// Library imports.
import axios, { AxiosResponse } from "axios";
import axiosInstance from '../axiosInstance';
import { baseWorker, IFiscalYear } from "../baseWorker";


// App imports.
import { config } from "../config";


export interface IFieldToUpdate {
  fuel: string
  , field: string
  , value: any
}

export interface INumHouseholdsByFuel {
  granteeId: number
  , fiscalYear: number
  , numberOfAssistedHouseholdsAll: number
  , numberOfAssistedHouseholdsElectric: number
  , numberOfAssistedHouseholdsNaturalGas: number
  , numberOfAssistedHouseholdsFuelOil: number
  , numberOfAssistedHouseholdsPropane: number
  , numberOfAssistedHouseholdsOther: number
}

export interface IAverageExpenditureByFuel {
  granteeId: number
  , fiscalYear: number
  , validPMDataReported: boolean
  , sedsAverageExpenditureAll: number
  , sedsAverageExpenditureElectric: number
  , sedsAverageExpenditureCodeElectric: string
  , sedsAverageExpenditureNaturalGas: number
  , sedsAverageExpenditureCodeNaturalGas: string
  , sedsAverageExpenditureFuelOil: number
  , sedsAverageExpenditureCodeFuelOil: string
  , sedsAverageExpenditurePropane: number
  , sedsAverageExpenditureCodePropane: string
  , sedsAverageExpenditureOther: number
  , computedAverageExpenditureAll: number
  , computedAverageExpenditureElectric: number
  , computedAverageExpenditureNaturalGas: number
  , computedAverageExpenditureFuelOil: number
  , computedAverageExpenditurePropane: number
  , computedAverageExpenditureOther: number
  , numberOfAssistedHouseholdsElectric: number
  , numberOfAssistedHouseholdsNaturalGas: number
  , numberOfAssistedHouseholdsFuelOil: number
  , numberOfAssistedHouseholdsPropane: number
  , numberOfAssistedHouseholdsOther: number
}

export class Worker extends baseWorker {
  //get basic userinfo for logged in drupal user


  public async getSedsData(inGranteeId: number, inFiscalYear: number): Promise<IAverageExpenditureByFuel> {
    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/datareliability/sedsdata/${inFiscalYear}/grantee/${inGranteeId}`);               
    let averageExpenditure: IAverageExpenditureByFuel = {
      fiscalYear: inFiscalYear,
      granteeId: inGranteeId,
      validPMDataReported: true,
      sedsAverageExpenditureAll: null,
      sedsAverageExpenditureElectric: null,
      sedsAverageExpenditureNaturalGas: null,
      sedsAverageExpenditureFuelOil: null,
      sedsAverageExpenditurePropane: null,
      sedsAverageExpenditureOther: null,
      sedsAverageExpenditureCodeElectric: '',
      sedsAverageExpenditureCodeNaturalGas: '',
      sedsAverageExpenditureCodeFuelOil: '',
      sedsAverageExpenditureCodePropane: '',
      computedAverageExpenditureAll: null,
      computedAverageExpenditureElectric: null,
      computedAverageExpenditureNaturalGas: null,
      computedAverageExpenditureFuelOil: null,
      computedAverageExpenditurePropane: null,
      computedAverageExpenditureOther: null,
      numberOfAssistedHouseholdsElectric: null,
      numberOfAssistedHouseholdsNaturalGas: null,
      numberOfAssistedHouseholdsFuelOil: null,
      numberOfAssistedHouseholdsPropane: null,
      numberOfAssistedHouseholdsOther: null,
    };

    //getSeds data
    if (response.data.length > 1) {
      response.data[0].map(datarow => {
        switch (datarow["FUEL_CD"]) {
          case "EL":
            averageExpenditure.sedsAverageExpenditureElectric = this.nullOrNumberToNumber(datarow["MAIN_HEAT"]);
            averageExpenditure.sedsAverageExpenditureCodeElectric = datarow["MAIN_HEAT_CODE"];
            break;
          case "NG":
            averageExpenditure.sedsAverageExpenditureNaturalGas = this.nullOrNumberToNumber(datarow["MAIN_HEAT"]);
            averageExpenditure.sedsAverageExpenditureCodeNaturalGas= datarow["MAIN_HEAT_CODE"];
            break;
          case "FO":
            averageExpenditure.sedsAverageExpenditureFuelOil = this.nullOrNumberToNumber(datarow["MAIN_HEAT"]);
            averageExpenditure.sedsAverageExpenditureCodeFuelOil = datarow["MAIN_HEAT_CODE"];
            break;
          case "PR":
            averageExpenditure.sedsAverageExpenditurePropane = this.nullOrNumberToNumber(datarow["MAIN_HEAT"]);
            averageExpenditure.sedsAverageExpenditureCodePropane = datarow["MAIN_HEAT_CODE"];
            break;
        }
      });
      if (response.data[1].length > 0) {
        averageExpenditure.computedAverageExpenditureElectric = this.nullOrNumberToNumber(response.data[1][0]["ELECTRIC_AVG_EXP"]);
        averageExpenditure.computedAverageExpenditureNaturalGas = this.nullOrNumberToNumber(response.data[1][0]["NATURAL_GAS_AVG_EXP"]);
        averageExpenditure.computedAverageExpenditureFuelOil = this.nullOrNumberToNumber(response.data[1][0]["FUEL_OIL_AVG_EXP"]);
        averageExpenditure.computedAverageExpenditurePropane = this.nullOrNumberToNumber(response.data[1][0]["PROPANE_AVG_EXP"]);
        averageExpenditure.numberOfAssistedHouseholdsElectric = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_ELECTRIC_MAIN_HEAT"]);
        averageExpenditure.numberOfAssistedHouseholdsNaturalGas = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_NATURAL_GAS_MAIN_HEAT"]);
        averageExpenditure.numberOfAssistedHouseholdsFuelOil = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_FUEL_OIL_MAIN_HEAT"]);
        averageExpenditure.numberOfAssistedHouseholdsPropane = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_PROPANE_MAIN_HEAT"]);
        averageExpenditure.numberOfAssistedHouseholdsOther = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_OTHER_MAIN_HEAT"]);

        //if a row was returend (i.e. this is a valid reporting year) but values are null, no valid pm data
        averageExpenditure.validPMDataReported = true;
        console.log('averageExpenditure', averageExpenditure);
        if (averageExpenditure.numberOfAssistedHouseholdsElectric === null
          && averageExpenditure.numberOfAssistedHouseholdsNaturalGas === null
          && averageExpenditure.numberOfAssistedHouseholdsFuelOil === null
          && averageExpenditure.numberOfAssistedHouseholdsPropane === null) {

          averageExpenditure.validPMDataReported = false;
          console.log('invalid');
        }

      }
    }
    return averageExpenditure;
  }
  public async getSedsCodeValues(): Promise<string[]> {
    let sedsValueCodesAssociativeArray: string[] = [];

    try {
      
      const response: AxiosResponse =
        //using the apiBaseURL property defined in config.ts which we import above
        await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/sedscodevalues`);               
      response.data.map(r => {
        sedsValueCodesAssociativeArray[r["SDCV_CD"]] = r["SDCV_NOTE_MH"];
      });
    }
    catch (error) {
      return this.handleError(error);
    }
    return sedsValueCodesAssociativeArray;
  }
  public async getNumhouseHolds(inGranteeId: number, inFiscalYear: number): Promise<INumHouseholdsByFuel> {

    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/datareliability/numhouseholds/${inFiscalYear}/grantee/${inGranteeId}`);

    let numHouseholds: INumHouseholdsByFuel = {
      fiscalYear: inFiscalYear,
      granteeId: inGranteeId,
      numberOfAssistedHouseholdsAll: null,
      numberOfAssistedHouseholdsElectric: null,
      numberOfAssistedHouseholdsNaturalGas: null,
      numberOfAssistedHouseholdsFuelOil: null,
      numberOfAssistedHouseholdsPropane: null,
      numberOfAssistedHouseholdsOther: null,
    };

    if (response.data.length > 0) {
      numHouseholds.numberOfAssistedHouseholdsAll = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_ALL"]);
      numHouseholds.numberOfAssistedHouseholdsElectric = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_ELECTRIC"]);
      numHouseholds.numberOfAssistedHouseholdsNaturalGas = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_NATURAL_GAS"]);
      numHouseholds.numberOfAssistedHouseholdsFuelOil = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_FUELOIL"]);
      numHouseholds.numberOfAssistedHouseholdsPropane = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_PROPANE"]);
      numHouseholds.numberOfAssistedHouseholdsOther = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_OTHER"]);
    }
    return numHouseholds;
  }

}
